import {
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalContentProps,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { ReactNode } from 'react';

type Props = {
  title?: string | ReactNode;
  description: string | ReactNode;
  button?: ReactNode | undefined;
  isOpen: boolean;
  onClose: () => void;
  modalContentProps?: ModalContentProps;
};

export const SimpleModal = ({
  title,
  description,
  button,
  isOpen,
  onClose,
  modalContentProps,
}: Props) => (
  <Modal isOpen={isOpen} onClose={onClose} isCentered>
    <ModalOverlay />
    <ModalContent maxWidth="90vw" {...modalContentProps}>
      <ModalHeader>{title}</ModalHeader>
      <ModalCloseButton color="primaryColor" />
      <ModalBody>
        <Center w="full" textAlign="center">
          {description}
        </Center>
      </ModalBody>
      <ModalFooter>{button && <Center w="full">{button}</Center>}</ModalFooter>
    </ModalContent>
  </Modal>
);
